
import PropTypes from 'prop-types'
import { useTimer } from 'react-timer-hook'
import { Grid } from '@mui/material'

const Countdown = ({ expiryTimestamp, onExpire }) => {
  const {
    seconds,
    minutes,
    hours,
    days,
    // isRunning,
    // start,
    // pause,
    // resume,
    // restart,
  } = useTimer({
    autoStart: true,
    expiryTimestamp,
    onExpire: () => {
      console.warn('onExpire called')
      onExpire()
    }
  })

  return (
    <Grid
      container
      sx={{
        width: '800px',
        textAlign: 'center',
        '@media (max-width: 1200px)': {
          width: '600px',
        },
        '@media (max-width: 90px)': {
          width: '400px',
        },
        '@media (max-width: 600px)': {
          width: '300px',
        },
      }}>
      <Grid item xs={3}>
        <div
          style={{
            borderRight: 'solid 2px rgba(221, 221, 221, 0.5)',
            '@media (max-width: 600px)': {
              borderRight: 'solid 1px rgba(221, 221, 221, 0.5)',
            },
          }}>
          <p
            style={{
              marginBottom: 40,
              color: '#DDDDDD',
              fontSize: '100px',
              fontFamily: 'ProximaNova-Bold',
              '@media (max-width: 1200px)': {
                marginBottom: 20,
                fontSize: '48px',
              },
              '@media (max-width: 600px)': {
                fontSize: '20px',
                marginBottom: 5,
              },
            }}>{days}</p>
          <span
            style={{
              marginTop: -40,
              color: '#DDDDDD',
              fontSize: '18px',
              fontFamily: 'ProximaNova-Regular',
              letterSpacing: '0.46px',
              '@media (max-width: 1200px)': {
                fontSize: '16px',
              },
              '@media (max-width: 600px)': {
                fontSize: '14px',
              },
            }}>Days</span>
        </div>
      </Grid>
      <Grid item xs={3}>
        <div
          style={{
            borderRight: 'solid 2px rgba(221, 221, 221, 0.5)',
            '@media (max-width: 600px)': {
              borderRight: 'solid 1px rgba(221, 221, 221, 0.5)',
            },
          }}>
          <p
            style={{
              marginBottom: 40,
              color: '#DDDDDD',
              fontSize: '100px',
              fontFamily: 'ProximaNova-Bold',
              '@media (max-width: 1200px)': {
                marginBottom: 20,
                fontSize: '48px',
              },
              '@media (max-width: 600px)': {
                fontSize: '20px',
                marginBottom: 5,
              },
            }}>{hours}</p>
          <span
            style={{
              marginTop: -40,
              color: '#DDDDDD',
              fontSize: '18px',
              fontFamily: 'ProximaNova-Regular',
              letterSpacing: '0.46px',
              '@media (max-width: 1200px)': {
                fontSize: '16px',
              },
              '@media (max-width: 600px)': {
                fontSize: '14px',
              },
            }}>Hours</span>
        </div>
      </Grid>
      <Grid item xs={3}>
        <div
          style={{
            borderRight: 'solid 2px rgba(221, 221, 221, 0.5)',
            '@media (max-width: 600px)': {
              borderRight: 'solid 1px rgba(221, 221, 221, 0.5)',
            },
          }}>
          <p
            style={{
              marginBottom: 40,
              color: '#DDDDDD',
              fontSize: '100px',
              fontFamily: 'ProximaNova-Bold',
              '@media (max-width: 1200px)': {
                marginBottom: 20,
                fontSize: '48px',
              },
              '@media (max-width: 600px)': {
                fontSize: '20px',
                marginBottom: 5,
              },
            }}>{minutes}</p>
          <span
            style={{
              marginTop: -40,
              color: '#DDDDDD',
              fontSize: '18px',
              fontFamily: 'ProximaNova-Regular',
              letterSpacing: '0.46px',
              '@media (max-width: 1200px)': {
                fontSize: '16px',
              },
              '@media (max-width: 600px)': {
                fontSize: '14px',
              },
            }}>Minutes</span>
        </div>
      </Grid>
      <Grid item xs={3}>
        <div>
          <p
            style={{
              marginBottom: 40,
              color: '#DDDDDD',
              fontSize: '100px',
              fontFamily: 'ProximaNova-Bold',
              '@media (max-width: 1200px)': {
                marginBottom: 20,
                fontSize: '48px',
              },
              '@media (max-width: 600px)': {
                fontSize: '20px',
                marginBottom: 5,
              },
            }}>{seconds}</p>
          <span
            style={{
              marginTop: -40,
              color: '#DDDDDD',
              fontSize: '18px',
              fontFamily: 'ProximaNova-Regular',
              letterSpacing: '0.46px',
              '@media (max-width: 1200px)': {
                fontSize: '16px',
              },
              '@media (max-width: 600px)': {
                fontSize: '14px',
              },
            }}>Seconds</span>
        </div>
      </Grid>
    </Grid>
  )
}

Countdown.propTypes = {
  expiryTimestamp: PropTypes.any,
  onExpire: PropTypes.func,
}

export default Countdown
